import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { Invitation, CreateInvitationInput } from '@peles/shared';
import * as invitationsApi from '../api/invitations';

export function useInvitations(eventId?: string) {
  return useQuery<Invitation[]>({
    queryKey: ['invitations', eventId],
    queryFn: () => invitationsApi.listInvitations(eventId),
  });
}

export function useCreateInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateInvitationInput) => invitationsApi.createInvitation(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invitations'] });
    },
  });
}

export function useValidateInvitation(token: string) {
  return useQuery({
    queryKey: ['invitations', 'validate', token],
    queryFn: () => invitationsApi.validateInvitation(token),
    enabled: !!token,
  });
}

export function useAcceptInvitation() {
  return useMutation({
    mutationFn: ({ token, name }: { token: string; name?: string }) =>
      invitationsApi.acceptInvitation(token, { name }),
  });
}
